import { styled } from 'helpers';
import { Dialog, DialogProps } from '../Dialog';
type SimpleModalProps = { maxHeight?: boolean } & DialogProps;
export const SimpleModalStyled = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'maxHeight',
})<SimpleModalProps>(({ hideBackdrop, maxHeight }) => ({
  '& .MuiDialog-container': {
    height: '100%',
  },
  '& .MuiDialog-paper': {
    maxHeight: maxHeight ? '80%' : 'calc(100% - 64px)',
    boxShadow: !hideBackdrop
      ? '2px 2px 16px rgba(34, 38, 72, 0.08)'
      : '10px 10px 30px rgba(34, 38, 72, 0.24)',
    borderRadius: 8,
  },
}));
